<app-layout>
  <div>
    <app-title title="picker.title" text="picker.text" />

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
      @if (noOrganization) {
        <div>
          You don't have any organization available.<br/>
          Cannot proceed with login.
        </div>
      }
    <ul>
      @for (org of organizations; track org.id) {
      <li (click)="useOrganization(org)">
        <span>{{org.orgName}}</span>
        <app-icon-chevron-right />
      </li>
      }
    </ul>
    }
  </div>
</app-layout>
